import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';


export const InfoBoxSmall = ({ messageId }: { messageId: string }) => (
    <div className='info-box'>
        <div className="flex">
            <FontAwesomeIcon icon={faInfoCircle} size='sm' style={{ marginRight: '1em' }} />
            <p>
                {messageId && <FormattedMessage id={messageId} />}
            </p>
        </div>
    </div>
);
